export default {
  title: '¿Estás seguro que quieres eliminar el recurso?',
  text: 'Al presionar eliminar se borrará el recurso de esta carpeta.',
  textAll: '¿Deseas quitar este recurso de todas las carpetas?',
  cancel: 'Cancelar',
  remove: 'Eliminar'
}

export const en = {
  title: 'Remove resource',
  text: 'Do you want to remove this resource from this folder?',
  textAll: 'Do you want to remote this resource from all folders?',
  cancel: 'Cancel',
  remove: 'Remove'
}

export const ca = {
  title: 'Elimina el recurs',
  text: 'Vols treure el recurs d\'aquesta carpeta?',
  textAll: 'Vols treure el recurs de totes les carpetes?',
  cancel: 'Cancel·la',
  remove: 'Treu'
}
